<template>
  <b-container class="page-container" style="background-color: #f0f0f0" fluid>
    <DeluxeCheckout />
  </b-container>
</template>
<style>

</style>

<script>
// @ is an alias to /src
import DeluxeCheckout from "@/components/checkout/deluxe/DeluxeCheckout.vue";

export default {
  title: 'Dropsmart Deluxe Checkout',
  name: "Deluxe",
  components: {
    DeluxeCheckout
  }
};
</script>
